import axios from 'axios'
import { API_URL } from '@/services/api.service.js'
import { logger } from '@/utils/logger'

/**
 * Fetches both backend and frontend version information
 * @returns {Promise<Object>} Combined version information containing both backend and frontend versions
 */
export const fetchVersions = async () => {
  let backendVersion = null
  let frontendVersion = null

  try {
    const backendResponse = await axios.get(`${await API_URL()}/version`, {})
    if (backendResponse.status === 200) {
      backendVersion = Object.keys(backendResponse.data).length > 0 ? backendResponse.data : null
    } else {
      logger.error('Backend version fetch failed:', backendResponse.statusText)
    }

    const frontendResponse = await fetch('/version.json')
    if (frontendResponse.ok) {
      frontendVersion = await frontendResponse.json()
    } else {
      logger.error('Frontend version fetch failed:', frontendResponse.statusText)
    }
  } catch (error) {
    logger.error('Error fetching versions:', error.message)
  }

  return {
    backend: backendVersion,
    frontend: frontendVersion
  }
}
